var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('span',[_vm._v(_vm._s(_vm.formatted))]):_c('span',{staticClass:"grey--text"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }